<template>
  <div class="overlay fixed w-100" @click="close" v-if="isVisible" />
</template>

<script>
import Overlay from '@vue-storefront/core/compatibility/components/Overlay'

export default {
  mixins: [Overlay],
  methods: {
    close () {
      this.$store.commit('ui/setOverlay', false)
      this.$store.commit('ui/setMicrocart', false)
      this.$store.commit('ui/setWishlist', false)
      this.$store.commit('ui/setSearchpanel', false)
      this.$store.commit('ui/setSidebar', false)
      this.$store.dispatch('themeCart/closeEditMode')

      this.$store.dispatch('supplies/minify')
    }
  }
}
</script>

<style lang="scss" scoped>
@use 'sass:map';
@use '~theme/css/helpers/functions/color' as *;
@import '~theme/css/base/global_vars';
$color-bg: color(black);
$z-index-overlay: map.get($z-index, overlay);

.overlay {
  height: 100vh;
  top: 0;
  left: 0;
  background-color: rgba($color-bg, 0.4);
  z-index: $z-index-overlay;
}
</style>
